import { fetcher } from '@commenda/utils';
import {
  AM_TP_DEMO_ROUTES,
  TAmDemoConfirmIntercompanyRequest,
  TAmDemoConfirmIntercompanyResponse,
  TAmDemoResult,
} from './types';

/**
 * Confirms which ledger flows are genuinely intercompany, creating the matrix rows the export reads.
 *
 * The export carries one row more than are confirmed here: the flow that was already classified before the scan
 * ran still belongs in the annex.
 */
export async function confirmAmTpDemoIntercompany(
  body: TAmDemoConfirmIntercompanyRequest
): Promise<TAmDemoResult<TAmDemoConfirmIntercompanyResponse>> {
  try {
    const response = await fetcher(AM_TP_DEMO_ROUTES.confirmIntercompany, {
      method: 'POST',
      body,
    });

    if (!response.ok) {
      return { success: false, error: 'Failed to confirm the transactions' };
    }

    return {
      success: true,
      data: (await response.json()) as TAmDemoConfirmIntercompanyResponse,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to confirm the transactions',
    };
  }
}
